import { Separator } from "@/components/ui/separator";
import { toast } from "sonner";
import { canvases2pdf } from "@/lib/utils";
import { Canvas } from "fabric";
import ImageEditor from "./image-editor";
import { useConfiguration } from "@/hooks";
import { Loader2 } from "lucide-react";

const LayoutPage = () => {
  const { data: configuration, isLoading: isConfigurationLoading } = useConfiguration();

  const handleExportPdf = async (canvases: Canvas[]) => {
    try {
      const pdfUrl = await canvases2pdf(canvases, "layouts");
      
      // Create a temporary link element to trigger download
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'layouts.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      URL.revokeObjectURL(pdfUrl);
      
      toast.success("Exito", {
        description: "El PDF se ha guardado en su computadora",
      });
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error al exportar PDF", {
        description: error instanceof Error ? error.message : (error as string),
      });
    }
  };

  return (
    <div className="grid gap-3 w-full">
      <div className="flex justify-between items-end gap-6">
        <div className="flex flex-col">
          <h1 className="text-lg font-semibold">Layouts</h1>
          <p className="text-xs text-muted-foreground">
            Suba imágenes o PDFs para crear layouts
          </p>
        </div>
      </div>
      <Separator />
      {isConfigurationLoading ? (
        <div className="flex justify-center items-center h-full">
          <Loader2 className="w-4 h-4 animate-spin" />
        </div>
      ) : (
        <ImageEditor onSave={handleExportPdf} configuration={configuration} />
      )}
    </div>
  );
};

export default LayoutPage;
